module.exports = __webpack_public_path__ + "static/media/Classplus-logo-small.ca8c40fb.svg";